import 'view/css/location.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileExcel,
  faPen,
  faPlus,
} from '@fortawesome/free-solid-svg-icons';

import moment from 'moment';
import React from 'react';

import API from 'service/api';
import Util, { Data } from 'service/util';

import BasePageView from 'view/BasePageView';
import Form from 'component/Form';
import PopMessage from 'component/pop-msg/PopMessage';
import Protected from 'component/Protected';

class ServiceLocationView extends BasePageView
{
  constructor(props)
  {
    super(props);
    this.state = {
      locations: [],
      filter_dist: '',
      filter_name: '',
      sort_by: '',
      modal: null,
      exporting: false,
    };

    this.title        = this.title.bind(this);
    this.showAddModal = this.showAddModal.bind(this);
    this.submitModal  = this.submitModal.bind(this);
    this.closeModal   = this.closeModal.bind(this);
  }

  componentDidMount() {
    API.getServiceLocationList().then(locations => {
      locations.forEach(l => l.cnt_vhT = l.cnt_vhA + l.cnt_vhB + l.cnt_vhC);
      this.setInitiated({locations});
    });
  }

  exportXls()
  {
    this.setState({exporting: true});
    API.exportLocationList().then(resp => {
      const ix_date = moment().format('YYYYMMDD');
      Util.download(resp, `服務地點資料_${ix_date}.xlsx`);
      this.setState({exporting: false});
    });
  }

  setv(key, value)
  {
    let modal = {...this.state.modal};
    modal.location[key] = value;
    this.setState({modal});
  }

  showAddModal()
  {
    let location = {
      srv_dis: this.state.locations[0].srv_dis, srv_loc: 0,
      name_zh: '', name_en: '',
      mgt_dis: '', cd_fleet: '', lhs_cmr: false
    };
    this.setState({modal:{mode:'add', location}});
  }
  showEditModal(location)
  {
    let origin = {...location};
    this.setState({modal:{mode:'edit', location, origin}});
  }

  closeModal()
  {
    if ('edit'===this.state.modal.mode)
      Object.assign(this.state.modal.location, this.state.modal.origin);
    this.setState({modal:null});
  }

  submitModal(e)
  {
    e.preventDefault();
    e.stopPropagation();

    let mode = this.state.modal.mode;
    let btn = e.target.querySelector('#btn-submit');
    btn.disabled = true;

    let fn_caller;
    switch (mode)
    {
      case 'add':  fn_caller = API.addLocation;  break;
      case 'edit': fn_caller = API.editLocation; break;
      default: throw 'location modal mode error';
    }

    fn_caller(this.state.modal.location).then(resp =>
    {
      if (resp.success) {
        if (mode === 'add') {
          let loc = resp.msg;
          loc.cnt_vhA = 0;
          loc.cnt_vhB = 0;
          loc.cnt_vhC = 0;
          loc.cnt_vhT = 0;
          loc.cnt_worker = 0;
          let locations = this.state.locations;
          locations.push(loc);
          Data.location.push(loc);
          locations.sort((a,b) => {
            if (a.srv_dis > b.srv_dis) return  1;
            if (a.srv_dis < b.srv_dis) return -1;
            if (a.srv_loc > b.srv_loc) return  1;
            if (a.srv_loc < b.srv_loc) return -1;
            return 0;
          });
          this.setState({modal:null, locations});
          PopMessage.show(`已新增新屋苑：${loc.srv_dis}${loc.srv_loc}。`,'成功','success');
        } else {
          this.setState({modal:null});
          PopMessage.show('已套用變更。','成功','success');
        }
      } else {
        let modal = {...this.state.modal};
        modal.error = resp.msg;
        this.setState({modal});
        PopMessage.show(resp.msg,'失敗','danger');
      }
      btn.disabled = false;
    });

    return false;
  }

  sort(key)
  {
    this.setState( (s,p) => { return {sort_by: {key, order: s.sort_by.key===key?-s.sort_by.order:1} }; });
  }

  isNoData = () => 1>this.state.locations.length;
  title = () =><>
    <span className="main-title">基本資料</span> - <span className="sub-title">服務地點</span>
  </>

  _render()
  {
    let locations = this.state.locations.filter(l => {
      if (!this.state.filter_dist)return true;
      return `${l.srv_dis}${l.srv_loc}`.startsWith(this.state.filter_dist);
    }).filter(l => {
      if (!this.state.filter_name)return true;
      return `${l.name_zh} ${l.name_en}`.toUpperCase().indexOf(this.state.filter_name) > -1;
    });

    if (this.state.sort_by) {
      let s_key   = this.state.sort_by.key;
      let s_order = this.state.sort_by.order;
      if (s_key === 'id') locations.forEach(l => l.id = `${l.srv_dis}${Util.LPAD(l.srv_loc,6)}`);

      locations.sort((a,b) => {
        if ( a[s_key] > b[s_key] ) return  s_order;
        if ( a[s_key] < b[s_key] ) return -s_order;
        return 0;
      });
    }

    return (
      <>
        <p className="message blue">
          數量為車輛最後一筆覆蓋本月的服務紀錄所屬的地點及工人。
        </p>
        <div className="search-bar box">
          <h4 className="box-head">
            <span>搜尋</span>
            <div className="button-group">
              <Protected allow={['ADMIN', 'OPERATOR']}>
                <button className="btn small green" type="button"
                        onClick={ this.showAddModal }>
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              </Protected>
            </div>
          </h4>
          <div className="box-body">
            <div className="action-panel">
              <div>
                <label className="search-field">
                  <span>編號</span>
                  <input id="f-district" value={ this.state.filter_dist }
                        onChange={ e => this.setState({filter_dist: e.target.value.toUpperCase().trimStart()}) }/>
                </label>
                <label className="search-field">
                  <span>屋苑或車場名稱</span>
                  <input id="f-location" value={ this.state.filter_name }
                        onChange={ e => this.setState({filter_name: e.target.value.toUpperCase().trimStart()}) }/>
                </label>
              </div>
              <div>
                <Protected allow={['ADMIN','OPERATOR','VIEWER_SU']}>
                  <button className="btn dark-green btn-export" disabled={this.state.exporting}
                    onClick={e=>this.exportXls()}>
                    <FontAwesomeIcon icon={faFileExcel} />
                    <span> 匯出</span>
                  </button>
                </Protected>
              </div>
            </div>
          </div>
        </div>
        <div className="locations">
          <table className="data-table full-width">
            <colgroup>
              <col width="20px" id="col-loc-sel"/>
              <col width="50px" id="col-loc-key"/>
              <col width="80px" id="col-loc-dist"/>
              <col width="auto" id="col-loc-name-zh"/>
              <col width="auto" id="col-loc-name-en"/>
              <col width="60px" id="col-loc-mgt-dist"/>
              <col width="60px" id="col-loc-fleet"/>
              <col width="60px" id="col-loc-cnt-A"/>
              <col width="60px" id="col-loc-cnt-B"/>
              <col width="60px" id="col-loc-cnt-C"/>
              <col width="80px" id="col-loc-cnt-total"/>
              <col width="80px" id="col-loc-cnt-worker"/>
              <col width="36px" id="col-loc-btn-grp"/>
            </colgroup>
            <thead>
              <tr>
                <th className="col-loc-sel"></th>
                <th className="col-loc-key"      onClick={ e => this.sort('id') }>編號</th>
                <th className="col-loc-dist"     onClick={ e => this.sort('srv_dis') }>地區</th>
                <th className="col-loc-name-zh"  onClick={ e => this.sort('name_zh') }>名稱(中)</th>
                <th className="col-loc-name-en"  onClick={ e => this.sort('name_en') }>名稱(英)</th>
                <th className="col-loc-mgt-dist" onClick={ e => this.sort('mgt_dis') }>管轄區</th>
                <th className="col-loc-fleet"    onClick={ e => this.sort('cd_fleet') }>車隊</th>
                <th className="col-loc-cnt-A right" title="Plan A"
                    onClick={ e => this.sort('cnt_vhA') }>A</th>
                <th className="col-loc-cnt-B right" title="Plan B"
                    onClick={ e => this.sort('cnt_vhB') }>B</th>
                <th className="col-loc-cnt-C right" title="Plan C"
                    onClick={ e => this.sort('cnt_vhC') }>C</th>
                <th className="col-loc-cnt-total right"
                    onClick={ e => this.sort('cnt_vhT') }>車輛總數</th>
                <th className="col-loc-cnt-worker right"
                    onClick={ e => this.sort('cnt_worker') }>工人數量</th>
                <th className="col-loc-btn-grp"></th>
              </tr>
            </thead>
            <tbody>
              { locations.map(l =>
                <label className="table-row" key={`${l.srv_dis}${l.srv_loc}`}>
                  <div className="col-loc-sel"><input type="checkbox" /></div>
                  <div className="col-loc-key">{ `${l.srv_dis}${l.srv_loc}` }</div>
                  <div className="col-loc-dist">{ Util.getDistrictName(l.srv_dis) }</div>
                  <div className="col-loc-name-zh">{ l.name_zh }</div>
                  <div className="col-loc-name-en">{ l.name_en }</div>
                  <div className="col-loc-mgt-dist">{ l.mgt_dis }</div>
                  <div className="col-loc-fleet">{ l.cd_fleet }</div>
                  <div className="col-loc-cnt-A" data-value={l.cnt_vhA}>
                    { Util.nf( l.cnt_vhA ) }
                  </div>
                  <div className="col-loc-cnt-B" data-value={l.cnt_vhB}>
                    { Util.nf( l.cnt_vhB ) }
                  </div>
                  <div className="col-loc-cnt-C" data-value={l.cnt_vhC}>
                    { Util.nf( l.cnt_vhC ) }
                  </div>
                  <div className="col-loc-cnt-total" data-value={l.cnt_vhT}>
                    { Util.nf( l.cnt_vhT ) }
                  </div>
                  <div className="col-loc-cnt-worker" data-value={l.cnt_worker}>
                    { Util.nf( l.cnt_worker ) }
                  </div>
                  <div className="col-loc-btn-grp">
                    <Protected allow={['ADMIN', 'OPERATOR']}>
                      <button className="btn-edit" title="編輯" onClick={e=>this.showEditModal(l)}>
                        <FontAwesomeIcon icon={faPen} />
                      </button>
                    </Protected>
                  </div>
                </label>
              )}
            </tbody>
          </table>
        </div>
        {
          !this.state.modal?'':
          <div className="modal">
            <div className="modal-box">
              {
                this.state.modal.mode==='add'
                ?<h2 className="modal-head">新增</h2>
                :<h2 className="modal-head">編輯 - {this.state.modal.location.srv_dis}{this.state.modal.location.srv_loc}</h2>
              }
              <Form className="modal-body" onSubmit={this.submitModal}>
                {
                  this.state.modal.mode!=='add'?'':
                  <label className="field">
                    <strong>地區</strong>
                    <select value={ this.state.modal.location.srv_dis }
                            onChange={ e=>this.setv('srv_dis', e.target.value )}>
                      { Data.district.map(dis=>
                        <option key={dis.cd} value={dis.cd}>{dis.cd} - {dis.name}</option>
                      ) }
                    </select>
                  </label>
                }
                <label className="field">
                  <strong>中文名稱</strong>
                  <input type="text" value={this.state.modal.location.name_zh}
                         onChange={ e=>this.setv('name_zh', e.target.value.trimStart() ) }/>
                </label>
                <label className="field">
                  <strong>英文名稱</strong>
                  <input type="text" value={this.state.modal.location.name_en}
                         onChange={ e=>this.setv('name_en', e.target.value.trimStart() ) }/>
                </label>
                <label className="field">
                  <strong>管轄區</strong>
                  <input type="text" value={this.state.modal.location.mgt_dis}
                         onChange={ e=>this.setv('mgt_dis', e.target.value.trim() ) }/>
                </label>
                <label className="field">
                  <strong>車隊</strong>
                  <input type="text" value={this.state.modal.location.cd_fleet}
                         onChange={ e=>this.setv('cd_fleet', e.target.value.trim() ) }/>
                </label>
                <label className="field">
                  <strong>優悠家居</strong>
                  <input type="checkbox" checked={this.state.modal.location.lhs_cmr}
                         onChange={ e=>this.setv('lhs_cmr', e.target.checked ) }/>
                </label>
                <div className="action-panel">
                  <button className="btn grey" type="button"
                          onClick={e=>this.closeModal()}>關閉</button>
                  <button id="btn-submit" className="btn blue">確定</button>
                </div>
              </Form>
            </div>
          </div>
        }
      </>
    );
  } // render()
} // end class

export default ServiceLocationView;